const DetailEditorialSkeleton = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-10 animate-pulse">
      <div className="grid lg:grid-cols-3 gap-10">
        {/* LEFT CONTENT */}
        <div className="lg:col-span-2">
          {/* TITLE */}
          <div className="h-10 bg-gray-300 rounded w-3/4 mb-4"></div>
          <div className="h-10 bg-gray-300 rounded w-1/2 mb-6"></div>

          {/* META */}
          <div className="flex gap-4 mb-6">
            <div className="h-4 w-16 bg-gray-200 rounded"></div>
            <div className="h-4 w-28 bg-gray-200 rounded"></div>
            <div className="h-4 w-20 bg-gray-200 rounded"></div>
          </div>

          {/* IMAGE */}
          <div className="w-full h-[350px] bg-gray-300 rounded-lg mb-6"></div>

          {/* CONTENT */}
          <div className="space-y-3">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="h-4 bg-gray-200 rounded w-full"></div>
            ))}
            <div className="h-4 bg-gray-200 rounded w-5/6"></div>
            <div className="h-4 bg-gray-200 rounded w-4/6"></div>
          </div>
        </div>

        {/* SIDEBAR */}
        <div className="space-y-10">
          {/* BERITA LAINNYA */}
          <div>
            <div className="h-6 w-40 bg-gray-300 rounded mb-4"></div>

            <div className="space-y-4">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="flex gap-3">
                  <div className="w-[90px] h-[70px] bg-gray-300 rounded"></div>

                  <div className="flex-1 space-y-2">
                    <div className="h-4 bg-gray-300 rounded w-full"></div>
                    <div className="h-4 bg-gray-300 rounded w-5/6"></div>
                    <div className="h-3 bg-gray-200 rounded w-24"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* BERITA POPULER */}
          <div>
            <div className="h-6 w-40 bg-gray-300 rounded mb-4"></div>

            <div className="space-y-4">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="flex gap-3">
                  <div className="w-[90px] h-[70px] bg-gray-300 rounded"></div>

                  <div className="flex-1 space-y-2">
                    <div className="h-4 bg-gray-300 rounded w-full"></div>
                    <div className="h-4 bg-gray-300 rounded w-5/6"></div>
                    <div className="h-3 bg-gray-200 rounded w-24"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailEditorialSkeleton;
